"use client";
import React, { useContext, createContext, useState } from "react";
import PropTypes from "prop-types";

export const NotifyStateContext = createContext();
export const NotifyUpdateContext = createContext();

export const NotifyProvider = ({ children }) => {
  const [isShown, setIsShown] = useState(false);

  const state = {
    isShown,
  };

  const updateFns = {
    setIsShown,
  };

  return (
    <NotifyUpdateContext.Provider value={updateFns}>
      <NotifyStateContext.Provider value={state}>
        {children}
      </NotifyStateContext.Provider>
    </NotifyUpdateContext.Provider>
  );
};

export function useNotifyState() {
  const state = useContext(NotifyStateContext);

  if (state === undefined) {
    throw new Error("useNotifyState must be used within a NotifyProvider");
  }

  return state;
}

export function useNotifyUpdate() {
  const updateFns = useContext(NotifyUpdateContext);

  if (updateFns === undefined) {
    throw new Error("NotifyUpdateContext must be used within a NotifyProvider");
  }

  return updateFns;
}

NotifyProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
